<div class="profile-container">
  <div class="">
      <div class="profile-content">
          <div class="personal-details">
              <h4 class="personal-details-title">COMPOSITION</h4>
              <div cdkDropListGroup class="composition-block">
                <div class="example-container-left">
                  <h2>Raw Material</h2>
                  <input type="text" class="form-control" placeholder="search product" [(ngModel)]="searchBoxTxt" (ngModelChange)="filterProducts()">
                  <hr>
                  <div
                    id="rawMaterialList"
                    cdkDropList
                    [cdkDropListData]="cProductListFilter"
                    class="example-list1"
                    (cdkDropListDropped)="drop($event)">
                    <div class="example-box1 d-flex justify-content-between align-items-center" *ngFor="let item of cProductListFilter; let i = index" cdkDrag>
                      <div>
                        <div style="font-weight: 500;">{{item.name}}</div>
                        <small class="text-muted" *ngIf="item.uom">UOM: {{item.uom}} | Price: {{item.price}}</small>
                      </div>
                      <span style="cursor: pointer; color: #3899e8;" (click)="addItem(item, i)" title="Add item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              
                <div class="example-container-right">
                  <h2>Formula Name</h2>
                  <div class="row">
                    <div class="col-md-12 col-lg-12">
                      <input type="text" placeholder="enter formula name" [(ngModel)]="productName" class="form-control">
                    </div>
                    <div class="col-md-2 col-lg-2">
                      <input type="number" min="0" placeholder="batch quantity" class="form-control" [(ngModel)]="batchQuantity" (input)="enforcePositiveNumber($event)">
                    </div>
                    <div class="col-md-2 col-lg-2">
                      <input type="number" min="0" placeholder="batch price" class="form-control" [(ngModel)]="batchPrice" (input)="enforcePositiveNumber($event)">
                    </div>
                    <div class="col-md-4 col-lg-4">
                      <div class="form-group ">
                        <ng-multiselect-dropdown
                        [placeholder]="'select uoms'"
                        [settings]="uomDropdownSettings"
                        [data]="uomDropdownList"
                        [(ngModel)]="uomSelectedList"
                        class="form-control"
                        style="padding: 0;border: none"
                        (onSelect)="onItemSelect($event)"
                        (onSelectAll)="onSelectAll($event)"
                        >
                        </ng-multiselect-dropdown>
                      </div>                     
                    </div>
                    <div class="col-md-4 col-lg-4" *ngIf="uomSelectedList.length != 0">
                      <select class="form-control" [(ngModel)]="isDefault">
                        <option value="" disabled selected hidden>-- select default uom --</option>
                        <option *ngFor="let uom of uomSelectedList" [value]="uom.uomMasterId">{{uom.uomName}}</option>
                      </select>
                    </div>
                  </div>
             

                  <div
                    id="doneList"
                    cdkDropList
                    [cdkDropListData]="done"
                    class="example-list"
                    (cdkDropListDropped)="drop($event)">
                    <div class="example-box" *ngFor="let item of done;let i = index" cdkDrag>
                      <div class="row input-data">
                        <div class="col-md-11 col-lg-11">
                          <p class="mb-2" style="font-weight: 500;">{{item.name}}</p>
                        </div>
                        <div class="col-md-1 col-lg-1 text-right">
                          <span style="cursor: pointer; color: #dc3545;" (click)="removeItem(item, i)" title="Remove item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                              <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3V2h11v1h-11Z"/>
                            </svg>
                          </span>
                        </div>
                        <!-- <div class="col-md-6 col-lg-6">
                          <label for="">Price:</label>
                          <p>{{item.price}}</p>
                        </div> -->
                        <div class="col-md-2 col-lg-2">
                          <label for="">Price:</label>
                          <input type="text" readonly class="form-control" value="{{item.price}}">
                        </div>
                        <div class="col-md-6 col-lg-6">
                          <label for="">UOM:</label>
                          <select class="form-control" (change)="uomChange($event,i)" [(ngModel)]="item.uom">
                            <option value="" disabled selected hidden>-- select uom --</option>
                            <option *ngFor="let uom of item.supportedUOM" [value]="uom.uomName">{{uom.uomName}}</option>
                          </select>
                        </div>
                      
                        <div class="col-md-2 col-lg-2">
                          <label for="">Quantity:</label>
                          <input type="number" min="0" class="form-control" (keyup)="amountChanged()" (input)="enforcePositiveNumber($event); amountChanged()" [(ngModel)]="item.qty">
                        </div>

                        <div class="col-md-2 col-lg-2">
                          <label for="">Sub Total:</label>
                          <input readonly type="text" class="form-control" value="{{item.price * item.qty}}">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="submit-footer">
                    <p>Amount: {{amount}}</p>
                    <div>
                      <button *ngIf="isEdit" class="view-b mr-2" (click)="cancel()">Back</button>
                      <button class="add-b" (click)="save()">submit</button>
                    </div>
                  </div>
                </div>
            </div>
          </div>

      </div>
  </div>
</div>

<div class="modal fade" id="viewModal" *ngIf="done.length != 0" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
          <div class="modal-header" style="position: relative;">
          <h5 class="modal-title text-center w-100" style="color: white; margin: 0 auto;" id="exampleModalLabel">COMPOSITION</h5>
              <span data-dismiss="modal" style="position: absolute; right: 15px; top: 15px; cursor: pointer;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-x-lg" viewBox="0 0 16 16" style="color: white !important;">
                      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                  </svg>
              </span>
          </div>
          <div class="modal-body">
            <table class="table table-striped" style="margin-bottom: 0;padding-bottom: 0;">
              <thead>
                <tr>
                  <th style="width: 50%;">Product</th>
                  <th style="width: 15%;text-align: center;">UOM</th>
                  <th style="width: 10%;text-align: center;">Price</th>
                  <th style="width: 10%;text-align: center;">Quantity</th>
                  <th style="width: 15%;text-align: center; white-space: nowrap;">Sub Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let product of done;let i = index">
                  <td>{{product.name}}</td>
                  <td style="text-align: center;">{{product.uom}}</td>
                  <td style="text-align: center;">{{product.price}}</td>
                  <td style="text-align: center;">{{product.qty}}</td>
                  <td style="text-align: center;">{{product.price * product.qty}}</td>
                </tr>    
              </tbody>
            </table>
              <div class="modal-footer" style="padding-right: 0;">
                <span style="float: left; font-weight: bold; margin-top: 5px;">Total Amount: {{amount}}</span>
                <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              </div>
          </div>
      </div>
  </div>
</div>